import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { AuthProvider, RequireAuth } from './lib/auth'
import SignIn from './pages/auth/SignIn'
import AuthError from './pages/auth/AuthError'
import Landing from './pages/landing/Landing'
import Privacy from './pages/landing/Privacy'
import Terms from './pages/landing/Terms'
import Dashboard from './pages/owner/Dashboard'
import CreateRegistry from './pages/owner/CreateRegistry'
import RegistryDetail from './pages/owner/RegistryDetail'
import ItemForm from './pages/owner/ItemForm'
import Settings from './pages/owner/Settings'
import Account from './pages/owner/Account'
import AcceptInvite from './pages/auth/AcceptInvite'
import RegistryPage from './pages/guest/RegistryPage'
import ContributeForm from './pages/guest/ContributeForm'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/r/:slug" element={<RegistryPage />} />
          <Route path="/r/:slug/contribute/:itemId" element={<ContributeForm />} />
          <Route path="/auth/sign-in" element={<SignIn />} />
          <Route path="/auth/error" element={<AuthError />} />
          <Route
            path="/me"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/me/new"
            element={
              <RequireAuth>
                <CreateRegistry />
              </RequireAuth>
            }
          />
          <Route
            path="/me/r/:rid"
            element={
              <RequireAuth>
                <RegistryDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/me/r/:rid/items/new"
            element={
              <RequireAuth>
                <ItemForm />
              </RequireAuth>
            }
          />
          <Route
            path="/me/r/:rid/items/:iid"
            element={
              <RequireAuth>
                <ItemForm />
              </RequireAuth>
            }
          />
          <Route
            path="/me/r/:rid/settings"
            element={
              <RequireAuth>
                <Settings />
              </RequireAuth>
            }
          />
          <Route
            path="/me/account"
            element={
              <RequireAuth>
                <Account />
              </RequireAuth>
            }
          />
          <Route path="/invites/:token" element={<AcceptInvite />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
